import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions, httpsCallable } from "firebase/functions";

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId:     process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
export const auth      = getAuth(app);
export const db        = getFirestore(app);
export const storage   = getStorage(app);
export const functions = getFunctions(app, "us-central1");

export const sendVerificationEmailFn  = httpsCallable(functions, "sendVerificationEmail");
export const sendPasswordResetFn      = httpsCallable(functions, "sendPasswordReset");
export const sendWelcomeEmailFn       = httpsCallable(functions, "sendWelcomeEmail");
export const sendPhoneChangeCodeFn    = httpsCallable(functions, "sendPhoneChangeCode");
export const verifyPhoneChangeCodeFn  = httpsCallable(functions, "verifyPhoneChangeCode");
